import { toast } from 'vue3-toastify'
import type { ToastOptions } from 'vue3-toastify'
import { useStorage } from '@vueuse/core'
import 'vue3-toastify/dist/index.css'

const { notifications } = useStorage('ls-dev-setting', { notifications: true }, localStorage).value
export const messageSettings = {
  position: toast.POSITION.TOP_CENTER,
  autoClose: 3000,
  clearOnUrlChange: false,
}

const formatMsg = (msg: string | string[]) => {
  return Array.isArray(msg) ? msg.join('\n') : msg
}
export const errorNotification = (msg: string | string[] = 'Error!') => {
  if (notifications) {
    toast.error(formatMsg(msg), {
      ...messageSettings,
    } as ToastOptions)
  } else {
    console.log(msg)
  }
}

export const infoNotification = (msg: string | string[] = 'info') => {
  if (notifications) {
    toast.info(formatMsg(msg), {
      ...messageSettings,
    } as ToastOptions)
  } else {
    console.log(msg)
  }
}

export const warningNotification = (msg: string | string[] = 'warning') => {
  if (notifications) {
    toast.warn(formatMsg(msg), {
      ...messageSettings,
    } as ToastOptions)
  } else {
    console.log(msg)
  }
}
export const successNotification = (msg: string | string[] = 'successful') => {
  if (notifications) {
    toast.success(formatMsg(msg), {
      ...messageSettings,
    } as ToastOptions)
  } else {
    console.log(msg)
  }
}
